export const QUICK_FILTER = {
  All: "null",
  Customer: "customer",
  Seller: "seller",
  "Order confirmation": "DEC25_ORDER_CONFIRMED_CUSTOMER",
  "Seller confirmation": "SELLER_NOTIFICATION_TEMPLATE",
};

export const CHANNEL_OPTIONS = {
  email: "EMAIL",
  Whatsapp: "WHATSAPP",
};

export const notificationStatuses = [
  {
    status: "processed",
    meaning: "Email accepted by SendGrid and queued for sending.",
  },
  {
    status: "delivered",
    meaning: "Successfully delivered to recipient’s device.",
  },
  { status: "deferred", meaning: "Temporary failure; email will be retried." },
  {
    status: "bounce",
    meaning: "Email rejected by the recipient’s server; won’t be retried.",
  },
  {
    status: "blocked",
    meaning: "Email blocked by the receiving server (e.g., spam filters).",
  },
  {
    status: "dropped",
    meaning:
      "Email not sent due to suppression (e.g., invalid email, unsubscribed).",
  },
  { status: "open", meaning: "Email was opened by the recipient." },
  { status: "click", meaning: "Recipient clicked a link in the email." },
  { status: "unsubscribe", meaning: "Recipient unsubscribed from all emails." },
  { status: "spamreport", meaning: "Recipient marked the email as spam." },

  // whatsapp

  { status: "message", meaning: "Message request is created in your system" },
  {
    status: "enqueued",
    meaning:
      "Message is accepted by Gupshup and queued for sending to WhatsApp.",
  },
  {
    status: "sent",
    meaning: "Message is successfully sent from Gupshup to WhatsApp servers.",
  },
  { status: "read", meaning: "Recipient has opened and read the message." },
  { status: "failed", meaning: "Message could not be sent or delivered" },
];

export const TO_DATE_ERROR = "To date should not be less than from date";
export const FROM_DATE_ERROR = "From date should not be greater than To date";

export const notificationHeader = [
  "Request Timestamp",
  "Last Status Timestamp",
  "Email/Mobile",
  "Provider Status",
  "Entity",
  "Notification Body",
  "Notification Attachment",
  "Template Name",
  "Order Number",
  "Channel",
  "Event ID",
];
